interface ProfileField {
    name: string;
    title?: Record<string, string>;
    type: "input" | "textarea" | "tag";
	required?: boolean;
	isPrivate?: boolean;
}

const baseProfileFields: Array<ProfileField> = [
	{
		name: "firstName",
		type: "input"
	},
	{
		name: "lastName",
		type: "input"
	},
	{
		name: "phoneNumber",
		type: "input",
		isPrivate: true
	},
	{
		name: "email",
		type: "input",
		isPrivate: true
	}
]

const shareContactsProfileFields: Array<ProfileField> = [
	...baseProfileFields
]

const defaultProfileFields: Array<ProfileField> = [
	...baseProfileFields,
	{
		name: "company",
		type: "input"
	},
	{
		name: "position",
		type: "input"
	},
	{
		name: "tagsIds",
		type: "tag",
		required: false
	},
	{
		name: "interestingTagIds",
		type: "tag",
		required: false
	}
]

export { ProfileField, defaultProfileFields, shareContactsProfileFields }